<div class="header-buttons pull-right row mr-0 ml-2">
    <!-- <button class="col" kendoButton [primary]="true" routerLinkActive="active" routerLink="/donor-information-entry"
    [queryParams]="{ 'sourcePage': 'newEntry'}" [icon]="'add'">
        <span>Add New Donor</span>
    </button> -->
</div>
<h3>Donor List</h3>
<form>
    <div class="card card-customize">
        <div class="card-block">

            <div class="row">
                <div class="col-md-12 mt-4">
                    <kendo-grid [data]="gridData" [columnMenu]="{sort: true, filter: true, columnChooser: false}"
                        [pageSize]="pageSize" [skip]="skip" (pageChange)="pageChange($event)"
                        (dataStateChange)="dataStateChange($event)" (filterChange)="filterChange($event)" [pageable]="{
                        buttonCount: buttonCount,
                        info: info,
                        type: typedg,
                        pageSizes: pageSizes,
                        previousNext: previousNext
                      }" filterable="menu" [filter]="filter">
                        <kendo-grid-column field="View" title="View" [headerStyle]="{'text-align':'left'}"
                            [width]="150">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <a class="hyperlink" routerLinkActive="active" routerLink="/donor-information-entry"
                                    [queryParams]="{'id': dataItem.donorId}">View Donor</a>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column title="Donor Agency Name" field="agencyName" [width]="150">
                            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                {{column.title}}
                            </ng-template>
                            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                                let-filterService="filterService">
                                <kendo-multiselect style="width:220px" [data]="agencyName" textField="agencyName"
                                    valueField="agencyName" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                                    (valueChange)="agencyNameChange($event, filterService)">
                                </kendo-multiselect>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.agencyName">
                                    <span> {{dataItem.agencyName}}</span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column title="City" field="city" [width]="150">
                            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                {{column.title}}
                            </ng-template>
                            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                                let-filterService="filterService">
                                <kendo-multiselect style="width:220px" [data]="city" textField="city" valueField="city"
                                    [valuePrimitive]="true" [value]="categoryFilters(filter)"
                                    (valueChange)="cityChange($event, filterService)">
                                </kendo-multiselect>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.city">
                                    <span> {{dataItem.city}}</span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column title="State" field="state" [width]="150">
                            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                {{column.title}}
                            </ng-template>
                            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                                let-filterService="filterService">
                                <kendo-multiselect style="width:220px" [data]="state" textField="state"
                                    valueField="state" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                                    (valueChange)="stateChange($event, filterService)">
                                </kendo-multiselect>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.state">
                                    <span> {{dataItem.state}}</span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column title="Country" field="countryName" [width]="150">
                            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                {{column.title}}
                            </ng-template>
                            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                                let-filterService="filterService">
                                <kendo-multiselect style="width:220px" [data]="country" textField="countryName"
                                    valueField="countryName" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                                    (valueChange)="countryNameChange($event, filterService)">
                                </kendo-multiselect>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.countryName">
                                    <span> {{dataItem.countryName}}</span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column title="IsActive" field="isActive" [width]="150">
                            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                {{column.title}}
                            </ng-template>
                            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
                                let-filterService="filterService">
                                <kendo-multiselect style="width:220px" [data]="isActive" textField="isActive"
                                    valueField="isActive" [valuePrimitive]="true" [value]="categoryFilters(filter)"
                                    (valueChange)="isActiveChange($event, filterService)">
                                </kendo-multiselect>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.isActive">
                                    <span> {{dataItem.isActive}}</span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>

                        <kendo-grid-column field="Awards" [width]="150">
                            <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
                                {{column.field}}
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span [title]="dataItem.awards">
                                    <span>{{dataItem.awards}} </span>
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </div>
            </div>
        </div>
    </div>
</form>